// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2MuU6","item":"PaymentsMobile_item__LFNH4","label":"PaymentsMobile_label__2LvrN","amount":"PaymentsMobile_amount__1zc-L"};